import Index from "../../pages/hjwq/springFestival/index";

const base = "springFestival";

const routes = [{
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index,
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index,
    },
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/hjwq/springFestival.js